import { CustomerIntelligenceData } from "VersionControl/Scripts/CustomerIntelligenceData";

/**
 *  Base interface for Change Details component props
 */
export interface IChangeDetailsPropsBase {
    customerIntelligenceData?: CustomerIntelligenceData;
}
